<template>
    <form style="width: 500px; margin: auto; background-color: #8A8D91; height: 68vh;" v-on:reset="rememberPassword()">
        <img src="https://mobipest.eu/wp-content/uploads/2021/01/mobipest_logo.png" style="width: 500px; height: 75px; margin-bottom: 25px;">
        <p v-if="remembered == false" style="text-align: left;">{{ $t('menu.enter_email') }}</p>
        <div style="width: 400px;" v-if="remembered == false">E-MAIL <div class="input-field inline" style="width: 338px"><input type="email" v-model="email" /></div>
        </div>
        <div v-if="remembered == false && remember">
            <div class="row">
                <div class="col offset-s1 s4" v-append="recaptcha"></div>
                <div class="col s4" v-if="nocaptchaError"></div>
            </div>
        </div>
        <p v-if="remembered == false" style="text-align: left; white-space: pre-line">{{$t("menu.restore_will_be_send")}}</p>
        <p v-if="remembered" style="font-size: 20px;">{{$t("menu.we_sent_you_guide_mail")}}</p>
        <p v-if="remembered" style="font-size: 32px; font-family: Futura-CondensedMedium;">{{email}}</p>
        <p v-if="remembered" style="font-size: 20px;">{{$t("menu.check_inbox")}}</p>
        <p v-if="remembered" style="font-size: 20px;"><a class="waves-effect waves-light btn-large" href="#/login">{{$t("menu.continue")}}</a></p>
        <p v-if="remembered == false">
            <a :disabled="isValid() == false" v-on:click="remember_sent()" class="waves-effect waves-light btn-large" style="margin-top: 0.25rem; margin-bottom: 0.25rem; background-color: #C22026; text-transform: initial;">
                <div v-if="remembering" class="preloader-wrapper small active">
                    <div class="spinner-layer spinner-red-only">
                        <div class="circle-clipper left">
                            <div class="circle"></div>
                        </div>
                        <div class="gap-patch">
                            <div class="circle"></div>
                        </div>
                        <div class="circle-clipper right">
                            <div class="circle"></div>
                        </div>
                    </div>
                </div>
                {{remembering == false ? $t('menu.send') : ""}}
            </a>
            <a href="#/login" class="waves-effect waves-light btn-large" style="margin-top: 0.25rem; margin-bottom: 0.25rem; background-color: #DADADA; text-transform: initial;">
                {{ $t('menu.cancel') }}
            </a>
        </p>
    </form>
</template>
<script>
import axios from 'axios';
export default {
    data: function() {
        return {
            email: "",
            remembered: false,
            remembering: false,
            remember: false,
            nocaptchaError: false,
            recaptcha: ""
        }
    },
    mounted: function(){
        this.rememberPassword()
        if(this.$parent.logged_in){
            this.$router.push('/desktop');
        }
    },
    methods: {
        isValid: function() {
            return this.email.length > 0;
        },
        rememberPassword: function() {
            this.remember = true
            axios.get('/users/password/new.json').then(response => {
                this.recaptcha = response.data.tags.slice(75, response.data.tags.length - 75);
                  let recaptchaScript = document.createElement('script')
                  recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js')
                  document.head.appendChild(recaptchaScript)
            })
        },
        remember_sent: function() {
            var that = this;
            this.remembering = true;
            axios.post('/users/password.json', { "user": { "email": this.email }, "g-recaptcha-response": grecaptcha.getResponse() }).then(response => {
                this.remembering = false;
                this.remembered = true;
            }).catch(function(reason) {
               that.remembering = false;
               if(_.isUndefined(reason.response.data['errors']) == false){
                    that.nocaptchaError = true;
               }
           });
        },
    }
}
</script>
<style scoped>
	p {
        font-size: 1em;
        text-align: center;
    }
</style>